import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { Capacitor } from '@capacitor/core';
import { Globals } from '../../globals';
import { StorageService } from '../storage/storage.service';
import {
  LogConsole,
  LogLocalStorage,
  LogPublisher,
  LogSqlite,
  LogWebApi,
} from './log-publishers';

const PUBLISHERS_FILE = 'assets/config/log-publishers.json';

// ****************************************************
// Log Publisher Config Definition Class
// ****************************************************
export interface LogPublisherConfig {
  loggerName: string;
  loggerLocation: string;
  isActive: boolean;
}

// ****************************************************
// Logging Publishers Service Class
// ****************************************************
@Injectable()
export class LogPublishersService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);
  private readonly storageService = inject(StorageService);

  constructor() {
    // Build publishers arrays
    this.buildPublishers();
  }

  // Public properties
  publishers: LogPublisher[] = [];

  // *************************
  // Public methods
  // *************************
  // Build publishers array
  buildPublishers(): void {
    let logPub: LogPublisher | undefined;

    for (const pub of this.globals.publishers.filter((p: any) => p.isActive)) {
      switch (pub.loggerName.toLowerCase()) {
        case 'localstorage':
          logPub = new LogLocalStorage();
          break;
        case 'webapi':
          logPub = new LogWebApi(this.http, this.globals);
          break;
        case 'sqlite':
          if (Capacitor.getPlatform() !== 'web') {
            logPub = new LogSqlite(this.storageService);
          } else {
            logPub = undefined;
          }
          break;
        default:
          logPub = new LogConsole();
          break;
      }

      if (logPub) {
        // Set location of logging
        logPub.location = pub.loggerLocation;
        // Add publisher to array
        this.publishers.push(logPub);
      }
    }
  }

  // *************************
  // Private methods
  // *************************
  private handleErrors(error: any): Observable<any> {
    const errors: string[] = [];
    let msg = '';

    msg = 'Status: ' + error.status;
    msg += ' - Status Text: ' + error.statusText;
    if (error.json()) {
      msg += ' - Exception Message: ' + error.json().exceptionMessage;
    }
    errors.push(msg);

    console.error('An error occurred', errors);

    return throwError(() => errors);
  }
}
